import React, { Component } from "react";
import { Helmet } from "react-helmet";

class PageHelmet extends Component {
  render() {
    const { pageTitle } = this.props;
    return (
      <>
        <Helmet>
          <title>{pageTitle ? `${pageTitle} |  Event  ` : " Event  "}</title>
          <meta
            name="description"
            content=" Event  "
          />
         
        </Helmet>
      </>
    );
  }
}

export default PageHelmet;
